import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { CasProfileApi } from "../../../services";

import type { UseLazyProfileReturnType } from "./types";

export const useLazyProfile = (): UseLazyProfileReturnType => {
  const { refetch: getUserProfile } = useQuery(QUERY_KEYS.profile, () => CasProfileApi.init().getProfile(), {
    enabled: false,
  });

  return { getUserProfile };
};
